module.exports = __webpack_public_path__ + "static/img/servocesBanner.bbb8a7ea.png";